import {ChartResults, ChartValues} from "../../../../actions/queryBuilderApi";
import _ from "lodash";

const swap = (values: ChartValues[], j: number) => {
    // swap column j with j + 1
    const tmp = JSON.parse(JSON.stringify(values.map(x => x.data[j + 1][1])))
    values.forEach(x => x.data[j + 1][1] = x.data[j][1])
    values.forEach((x, y) => x.data[j][1] = tmp[y])
}

const swapLabels = (labels: string[], j: number) => {
    const label = labels[j + 1]
    labels[j + 1] = labels[j]
    labels[j] = label
}

export const bubbleSortStack = (chartData: ChartResults, sort: number) => {
    const arr = chartData.values

    // find the highest index, can't use array.length because of missing values
    const dataLen = arr
        .map(i => i.data
            .map(j => j[0])
            .reduce((a, b) => Math.max(a, b), 0)
        )
        .reduce((a, b) => Math.max(a, b), 0)

    const labelLen = chartData.labels.length
    // fill gaps in data
    for (let i = 0; i < arr.length; i++) {
        const data = arr[i].data
        for (let j = 0; j <= dataLen; j++) {
            if (data.length > j && data[j]) {
                if (data[j][0] !== j) {
                    // @ts-ignore
                    data.splice(j, 0, [j, null])
                }
            } else {
                // @ts-ignore
                data.splice(j, 0, [j, null])
            }
        }
    }

    for (let i = 0; i < labelLen; i++) {
        for (let j = 0; j < labelLen - i - 1; j++) {
            const a = _.sum(arr.map(x => x.data.length > j ? x.data[j][1] : 0))
            const b = _.sum(arr.map(x => x.data.length > j + 1 ? x.data[j + 1][1] : 0))
            if (((a - b) * sort) > 0) {
                swap(arr, j)
                swapLabels(chartData.labels, j)
            }
        }
    }
}

export const bubbleSortLine = (chartData: ChartResults, sort: number) => {
    chartData
        .values
        .forEach(x => {
                const arr = x.data
                const length = arr.length
                for (let i = 0; i < length; i++) {
                    for (let j = 0; j < length - i - 1; j++) {
                        const num = (arr[j][1] - arr[j + 1][1]) * sort;
                        if (num > 0) {
                            swap(chartData.values, j)
                            swapLabels(chartData.labels, j)
                        }
                    }
                }
            }
        )
}